import { useEffect } from "react";
import { useDispatch } from "react-redux";

import ChatLayout from "../../components/chat/ChatLayout";
import { createSocketConnection, getSocket } from "../../redux/features/chat/socket";
import { initChatSocket } from "../../redux/features/chat/chatSocketHandlers";
import { getToken } from "../../utils/pip";

const ChatPage = ({ userId, role }) => {
  const dispatch = useDispatch();
  useEffect(() => {
 const token = getToken(role);
  if (!token) return;

  // 🔑 ALWAYS create socket if token exists
  const socket = createSocketConnection(token);

  // init listeners AFTER socket exists
  initChatSocket(dispatch);

  }, [userId, role]);

  return <ChatLayout userId={userId} role={role} />;
};

export default ChatPage;
